var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10703_717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6777 1.2959C35.8376 0.224119 37.6734 0.200553 38.6494 1.43555C39.7194 2.55648 39.7797 4.11508 38.8271 5.28418L38.6211 5.51465L16.0371 28.5967C15.4626 29.1839 14.7484 29.4999 14.0107 29.5C13.3651 29.5 12.7369 29.2586 12.2051 28.8047L11.9834 28.5967L1.37891 17.7578C0.207149 16.5599 0.206949 14.8443 1.37891 13.6465L1.60059 13.4395C2.13229 12.9855 2.75977 12.7442 3.40527 12.7441C4.1414 12.7441 4.85472 13.0578 5.42871 13.6426L14.1035 22.3174L34.5674 1.40332L34.6777 1.2959Z",
    fill: "#6FA0FF",
    stroke: "#6FA0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10703_717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheck);
export default __webpack_public_path__ + "static/media/blue-check.f2d4738b1aa3e2c37bf267339fd09f3e.svg";
export { ForwardRef as ReactComponent };